const SET_EXPERT = 'setExpert'
const SET_EXPERTS = 'setExperts'

export const mutationTypes = {
  SET_EXPERT,
  SET_EXPERTS
}

export const mutations = {
  [SET_EXPERT] (state, payload) {
    state.expert = payload
  },

  [SET_EXPERTS] (state, payload) {
    state.experts = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/expert/mutations.js